import React from 'react';
import { Shield, Lock, Users, History, Server } from 'lucide-react';

const HEADING = { fontFamily: "'Space Grotesk', system-ui, sans-serif" } as const;

const SECURITY_FEATURES = [
  { icon: Lock, title: 'Chiffrement bout en bout', description: 'Données chiffrées en transit (TLS 1.3) et au repos (AES-256).' },
  { icon: Users, title: "Contrôle d'accès granulaire", description: 'Qui voit quoi, par projet et par rôle.' },
  { icon: History, title: 'Audit complet', description: "Chaque action tracée. Historique consultable à tout moment." },
  { icon: Server, title: 'Infrastructure européenne', description: 'Hébergement en France. Conforme RGPD.' },
];

export function SecuritySection() {
  return (
    <section className="py-24 md:py-32 bg-[#0a0a1a] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-[2.5rem] bg-gradient-to-br from-[#141432] to-[#1e1e5a] border border-[#4f46e5]/30 p-8 md:p-14 relative overflow-hidden">
          <div className="absolute -top-20 -left-20 w-96 h-96 bg-[#4f46e5]/15 blur-[120px] rounded-full pointer-events-none" />
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center relative">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0a0a1a]/60 text-[#a5b4fc] text-xs font-bold uppercase tracking-widest mb-6 border border-[#4f46e5]/30">
                <Shield className="h-3.5 w-3.5" />
                Sécurité & Fiabilité
              </div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 tracking-tighter" style={HEADING}>
                Vos données{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4f46e5] to-[#a5b4fc]">
                  entre de bonnes mains
                </span>
              </h2>
              <p className="text-lg text-slate-300 mb-8">
                Sécurité et disponibilité pensées dès le départ. Souveraineté européenne, isolation stricte des workspaces, audit complet.
              </p>
              <div className="grid grid-cols-3 gap-6">
                {[
                  { v: '99.9%', l: 'Uptime garanti' },
                  { v: 'RGPD', l: 'Conforme' },
                  { v: 'EU', l: 'Hébergement' },
                ].map((s) => (
                  <div key={s.l}>
                    <div className="text-3xl md:text-4xl font-bold text-white mb-1 tabular-nums" style={HEADING}>{s.v}</div>
                    <div className="text-sm text-slate-400">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="grid gap-4">
              {SECURITY_FEATURES.map((feature) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={feature.title}
                    className="flex gap-4 p-5 rounded-2xl bg-[#0a0a1a]/50 border border-white/5 hover:border-[#4f46e5]/40 transition-colors"
                  >
                    <div className="p-2 h-fit rounded-lg bg-[#4f46e5]/15 border border-[#4f46e5]/20">
                      <Icon className="h-5 w-5 text-[#a5b4fc]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-white mb-1" style={HEADING}>{feature.title}</h3>
                      <p className="text-sm text-slate-400">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
